import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/refresh.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-up-light.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron-down-light.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-3a739c6b")

_pushScopeId("data-v-3a739c6b")
const _hoisted_1 = {
  class: "relative flex flex-col py-1 px-2 bg-gray-lp-1000 border border-gray-lp-1400 rounded-lg",
  style: {"min-width":"174px"}
}
const _hoisted_2 = { class: "text-12px text-gray-lp-300 font-semibold" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center relative mr-1"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_discount = _resolveComponent("discount")!
  const _component_detail_estimation = _resolveComponent("detail-estimation")!
  const _component_ModalErrorBalance = _resolveComponent("ModalErrorBalance")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Total tarif")), 1),
      _createVNode("div", _hoisted_3, [
        (_ctx.formType === 'manual' && _ctx.dataProfile.account_type === 'partner')
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _withDirectives(_createVNode(_component_Tooltip, {
                title: "",
                message: _ctx.$t('bookingShipment.tooltip.updateCost'),
                footer: "",
                isArrowBottom: false,
                isArrowRight: "",
                style: {"width":"150px","margin-top":"-0.5em","margin-left":"-11em"}
              }, null, 8, ["message"]), [
                [_vShow, _ctx.isOpenTooltip]
              ]),
              _createVNode("img", {
                class: "cursor-pointer w-4",
                alt: "",
                src: _imports_0,
                onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOpenTooltip(true))),
                onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenTooltip(false))),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateEstimationPrice && _ctx.updateEstimationPrice(...args)))
              }, null, 32)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args))),
          class: "text-16px flex items-center cursor-pointer text-gray-lp-300 font-semibold"
        }, _toDisplayString(_ctx.formType === "client" || _ctx.dataProfile.account_type === "client"
            ? _ctx.formatPriceMasked
            : _ctx.payload.isCOD
            ? _ctx.currency(_ctx.dataDetail.codAmount)
            : _ctx.isDiscountActive && !_ctx.isCODOnly
            ? _ctx.currency(_ctx.dataDetail.totalTariffAfterDiscount)
            : _ctx.currency(_ctx.bigLabelTotalTariff)), 1),
        (_ctx.formType === 'manual' && _ctx.dataProfile.account_type === 'partner')
          ? (_openBlock(), _createBlock("div", {
              key: 1,
              class: "flex items-center ml-2",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
            }, [
              _createVNode("img", {
                alt: "up",
                class: `cursor-pointer ${_ctx.isShow ? '' : 'hidden'} w-3`,
                src: _imports_1
              }, null, 2),
              _createVNode("img", {
                alt: "down",
                class: `cursor-pointer ${_ctx.isShow ? 'hidden' : ''} w-3`,
                src: _imports_2
              }, null, 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", {
        class: "flex cursor-pointer",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
      }, [
        (
          _ctx.formType === 'manual' &&
            _ctx.dataProfile.account_type === 'partner' &&
            _ctx.isDiscountActive
        )
          ? (_openBlock(), _createBlock(_component_discount, {
              key: 0,
              showDiscountNominal: _ctx.isCODOnly ? false : _ctx.showDiscountNominal,
              discountData: _ctx.discountData.data,
              tariffAfterDiscount: _ctx.bigLabelTotalTariff,
              defaultDiscount: _ctx.dataDetail.listDiscount
            }, null, 8, ["showDiscountNominal", "discountData", "tariffAfterDiscount", "defaultDiscount"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_detail_estimation, {
        class: "top-parent",
        isShow: _ctx.isShow,
        dataDetail: _ctx.dataDetail,
        isDiscountActive: _ctx.isDiscountActive,
        isCodRetail: _ctx.isCodRetail,
        isForeignCurrency: !_ctx.accountIsNonForeign,
        goodsValue: _ctx.goodsValue,
        isCOD: _ctx.payload.isCOD,
        isDFOD: _ctx.payload.isDFOD,
        discountData: _ctx.discountData.data,
        isInternational: _ctx.isInternational,
        isCrossCountryCod: _ctx.isCrossCountryCod,
        prefixCurrency: _ctx.prefixCurrency,
        destinationCurrencyLocale: _ctx.destinationCurrencyLocale
      }, null, 8, ["isShow", "dataDetail", "isDiscountActive", "isCodRetail", "isForeignCurrency", "goodsValue", "isCOD", "isDFOD", "discountData", "isInternational", "isCrossCountryCod", "prefixCurrency", "destinationCurrencyLocale"])
    ], 512), [
      [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
    ]),
    _createVNode(_component_ModalErrorBalance, {
      modelValue: _ctx.balanceUnderLimit,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.balanceUnderLimit = $event))
    }, null, 8, ["modelValue"])
  ], 64))
})